import React from 'react';
import './Footer.scss';
import TelegramIcon from './icons/telegram.png';
import ViberImage from './icons/viber.png';
import ContactImage from './icons/contacts.png';
import ShipingImage from './icons/shiping.png';
import SizeImage from './icons/size.png';
import ChangeImage from './icons/change.png';
import QuestionImage from './icons/question.png';
//#817E7E

export interface FooterComponentProps {}

const FooterComponent: React.FunctionComponent<FooterComponentProps> = (props) => {
  return (
    <>
      <footer>
        {/*Column container 1*/}
        <div className="services">
          <span>
            <img className="contacts" src={ContactImage} alt="TelegramIcon" />
            Контакти
          </span>
          <span>
            <img className="contacts" src={ShipingImage} alt="TelegramIcon" />
            Оплата та доставка
          </span>
          <span>
            <img className="contacts" src={SizeImage} alt="TelegramIcon" />
            Як обрати розмір
          </span>
          <span>
            <img className="contacts" src={ChangeImage} alt="TelegramIcon" />
            Обмін та повернення
          </span>
          <span>
            <img className="contacts" src={QuestionImage} alt="TelegramIcon" />
            Запитання
          </span>
        </div>
        <div className="messengers-info">
          <a href="https://womans-choice.com.ua/" className="messengers-info-sub" target="blank">
            <span>
              <img className="telegram-logo" src={TelegramIcon} alt="TelegramIcon" />
            </span>
            <span>
              <span>Написати в</span>
              <br />
              <span>TELEGRAM</span>
            </span>
          </a>
          <a href="https://womans-choice.com.ua/" className="messengers-info-sub" target="blank">
            <span>
              <img className="viber-logo" src={ViberImage} alt="Viber Icon" />
            </span>
            <span>
              <span>Написати у</span>
              <br />
              <span>VIBER</span>
            </span>
          </a>
        </div>
        <div className="email">
          <span>E-mail:</span>
          <a href="https://womans-choice.com.ua/">support@home-shop.in.ua</a>
        </div>
      </footer>
    </>
  );
};

export { FooterComponent };
